var map = {
	"./app-store-en.svg": "2d91",
	"./check_in.svg": "f7d8",
	"./check_out.svg": "7df6",
	"./congestion-status-dining-hall_even.svg": "a329",
	"./congestion-status-dining-hall_odd.svg": "422a",
	"./congestion-status-laundry_even.svg": "98d4",
	"./congestion-status-laundry_odd.svg": "ad23",
	"./food-information_even.svg": "16d9",
	"./food-information_odd.svg": "f7b8",
	"./google-play-en.svg": "608d",
	"./hotel-icon.svg": "f281",
	"./inquiry_even.svg": "7f06",
	"./inquiry_odd.svg": "96bd",
	"./intercom_even.svg": "1140",
	"./intercom_odd.svg": "d672",
	"./official-website_even.svg": "0c0e",
	"./official-website_odd.svg": "dc71",
	"./onsen_even.svg": "ab4c",
	"./onsen_odd.svg": "18df",
	"./tourist-information_even.svg": "f209",
	"./tourist-information_odd.svg": "7e18",
	"./wifi_even.svg": "0ca5",
	"./wifi_odd.svg": "9d4f",
	"./zoom_in.svg": "f184"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "97d9";